import { render } from "./Reference.vue?vue&type=template&id=50b4d2fb&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=ts"
export * from "./Reference.vue?vue&type=script&lang=ts"

import "./Reference.vue?vue&type=style&index=0&id=50b4d2fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50b4d2fb"

export default script